import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { BOISvg, SvgIcon } from '$components/elements/svg-icon';

type BasketUspProps = {
    bgColor?: string;
    icon: keyof typeof BOISvg;
};

export const BasketUsp: FC<React.PropsWithChildren<BasketUspProps>> = ({
    bgColor,
    icon,
    children,
}: React.PropsWithChildren<BasketUspProps>) => (
    <StyledBasketUsp flex alignItems="center" bgColor={bgColor}>
        <UspIcon size={30} svg={icon} />
        {children}
    </StyledBasketUsp>
);

const StyledBasketUsp = styled(Flex)<{ bgColor?: string }>(({ theme, bgColor }) => ({
    marginBottom: theme.space[7],
    padding: `${theme.space[7]} ${theme.space[9]}`,
    backgroundColor: bgColor ? bgColor : 'transparent',
    borderRadius: theme.general.borderRadius,
}));

const UspIcon = styled(SvgIcon)(({ theme }) => ({
    marginRight: theme.space[7],
}));
